export const removeQueryStringParams = (string) => {
  return typeof string === 'string' ? string.split('?')[0] : '';
};
